import { render, staticRenderFns } from "./inputName.vue?vue&type=template&id=2df72ca4&scoped=true"
import script from "./inputName.vue?vue&type=script&lang=js"
export * from "./inputName.vue?vue&type=script&lang=js"
import style0 from "./inputName.vue?vue&type=style&index=0&id=2df72ca4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df72ca4",
  null
  
)

export default component.exports